import { useEffect, useState } from "react"
import { Button, Card, Col, Container, Row ,Alert} from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router"
import Get from "../api/Get"
import { APPOINTMENT_DEMAND_LINK } from "../api/Routes"
import { getIpPublic } from "../utils/getIpPublic"
import AutoagendamientoOnDemand from "./AutoagendamientoOnDemand"
import logo2 from "../img/autoagendamientov2/logo_ike_home.png";
import logoMty from "../img/autoagendamientov2/mty.png";

function SalaVideoConferencia({t}){
    const {idSpeciality, idAccount} = useParams()
    const history = useHistory()
    const [aproved, setAproved] = useState(true)
    const [autoagendar, setAutoagendar] = useState(false)
    const [speciality, setSpeciality] = useState(null)
    const [account, setAccount] = useState(null)
    const [company, setCompany] = useState(null)
    const [errorServer, setErrorServer] = useState(false)

    // Logo Mty
    const logo = idAccount == "1163" ? logoMty : logo2;
    //const logo = logo2;



    useEffect(()=>{
        let mounted = true
        getIpPublic()
        .then(resp=>{
            if(mounted){
                Get({url: `${APPOINTMENT_DEMAND_LINK}/${idSpeciality}/${idAccount}/${resp}`, noToken: true})
                .then(response=>{
                    //console.log(response)
                    setAproved(response.data.data.approved)
                    if(response.data.data.approved){
                        history.replace(`/public/conferencia/${btoa(response.data.data.id)}`)
                    }else{
                        setSpeciality(response.data.data.speciality)
                        setAccount(response.data.data.patientDTO.account)
                        setCompany(response.data.data.patientDTO.company)
                    }                
                })
                .catch(error=>{
                    setErrorServer(true)
                    setAproved(false)
                })
            }
        })
        .catch(error=>{
            setErrorServer(true)
            setAproved(false)
        })
        return () => mounted = false;
    }, [])

    return(
        !autoagendar ?
        <Container fluid className="content h-100vh py-5">
            <Row className="my-5">
                <Col xs="12" md={{span: 4, offset: 4}}>
                    <Card className="shadow-sm">
                        {
                            errorServer ?
                            <Card.Body className="text-center">
                                <h3>Lo sentimos!!!!</h3>
                                <div className="mt-4 text-center">
                                    <p>
                                        Estamos teniendo problemas con la comunicación. Nuestros técnicos están haciendo todo lo posible
                                        para restablecer el servicio. 
                                    </p>
                                    <Button variant="link" onClick={() => window.location.reload()}>{t('volver_intentar')}</Button>
                                </div>
                            </Card.Body> : 
                            aproved ? 
                            <Card.Body className="text-center">
                                <h3>{t('buscando_disponiblidad')}</h3>
                                <div className="mt-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </Card.Body> : 
                            <Card.Body className="text-center">
                               {/*  <div>
                                    <h3>{t('lo_sentimos')}</h3>
                                    <p>{t('info_no_medico')}</p>
                                    <Button variant="link" onClick={() => window.location.reload()}>{t('volver_intentar')}</Button>
                                </div>
                                {
                                    account?.helpCenter && 
                                    <Row>
                                        <Col>
                                            <Alert className="p-1" variant="light">
                                                <span className="font-size-09rem text-secondary font-weight-bold">
                                                    {account?.helpCenter}
                                                </span>
                                            </Alert>
                                        </Col>
                                    </Row>
                                } */}
                                <div>
                                    <h3>Bienvenido al servicio de </h3>
                                    <h3>Orientación y asistencia médica</h3>
                                </div>
                                <div>
                                <img src={logo} alt="Iké" width={120} />
                            </div>
                                <div className="border border-secondary mt-3 p-2">
                                <h3>Para consultar el mejor horario para ti, da click en el siguiente botón.</h3>
                                  
                                    <Button variant="primary" size="md" onClick={e=>setAutoagendar(true)} type="button">{t('agendar_cita')}</Button>
                                </div>
                            </Card.Body>
                        }                        
                    </Card>
                </Col>
            </Row>
        </Container> : 
        <AutoagendamientoOnDemand speciality={speciality} account={account} company={company} source="autoagendamientoapp"/>
 
    )
}

export default withTranslation()(SalaVideoConferencia)